import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";
import Typography from "@mui/material/Typography";

type AvailableAmountProps = {
  availableAmount: number;
  totalAmount: number;
  boxProps?: BoxProps;
};

const AvailableAmount: FC<AvailableAmountProps> = ({
  availableAmount,
  totalAmount,
  boxProps = {},
}) => {
  return (
    <Box display="flex" flexWrap="wrap" mb={1} {...boxProps}>
      {availableAmount !== 0 && totalAmount !== 0 ? (
        <>
          <Typography variant="body2" mr={0.75}>
            {availableAmount || 0} AVAILABLE
          </Typography>
          <Typography color="grey.500" variant="body2">
            OUT OF {totalAmount}
          </Typography>
        </>
      ) : totalAmount === 0 ? (
        <Typography color="grey.500" variant="body2">
          MULTIPLE ITEMS AVAILABLE
        </Typography>
      ) : (
        <Typography color="grey.500" variant="body2">
          OUT OF STOCK
        </Typography>
      )}
    </Box>
  );
};
export default AvailableAmount;
